import {useMemo, useRef, useState} from 'react';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { createTheme } from '@mui/material/styles';
import { StyledAccordionContainer, StyledFieldBox, StyledGridContainer} from '../../Components/Styled/index';
import { ACTIVE_STATUS,LEAD_DESIRABILITY,LEAD_STATUS, STATIC_ENTITY_CONFIG, handleValidateCodevalue } from '../../Utility/constant';
import { WhoColumns } from '../../Components/WhoColumns';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import NumericTextField from '../../Components/NumericTextfield';
import CommonEmail from '../../Components/CommonEmail';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import CommonPoc from '../../Components/CommonPoc';
import { ChooseProductType } from '../../Components/ChooseProductType';
import { getEntityColumns } from '../../Utility/apiHelper';
import PhoneNumberField from '../../Components/PhoneNumberField';
import './Lead.css';

const theme = createTheme({
    typography: {
      subtitle2: {
        fontStyle: 'italic',
      }
    },
});



const SearchLeadComponenet = ({handleSelectOwner,handleSelectStatus,ownerlistdropdown,entityDetails,handleOnChange}) => {
    const inputSearchRef = useRef(null);
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const leadStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
     const [isVisible , setIsVisible] = useState(false)
    const leadDesrirabilityData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_DESIRABILITY)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const leadTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "LEAD");

        return Object.keys(data).length > 0
            ? data
            : STATIC_ENTITY_CONFIG?.LEAD;
    }, [allEntityData]);

  return (
     <Box className="search-lead-form-box">
    <StyledGridContainer>
        
    {leadTextfieldsData?.id?.visibility && (
        <TextFiledWithLabel
            type="number"
            name="id"
            value= {entityDetails?.id}
            label={handleValidateCodevalue(internationalise,'LEAD_SEARCH_LEAD_ID')}
            handleOnChange={handleOnChange}
        />
    )}
    {leadTextfieldsData?.customerId?.visibility && (
        <TextFiledWithLabel
            type = "number"
            name="customerId" 
            value={entityDetails?.customerId}
            label={handleValidateCodevalue(internationalise,"LEAD_SEARCH_CUSTOMER_ID")} 
            handleOnChange={handleOnChange}
        />
    )}
    </StyledGridContainer>
    <StyledAccordionContainer>
    <AutoCompleteComponent
        className="search-lead-autocomplete"
        limitTags={3}
        textInputStyle = {{ width: "97% !important" }}
        multiple
        optionSet={ownerlistdropdown}
        value={entityDetails?.selectedOwner || []}
        name="managerId"
        placeholder={handleValidateCodevalue(internationalise,'LEAD_SEARCH_OWNER')}
        disabled={!(specificRolePermission?.isAllLeadManage || specificRolePermission?.isLeadTeamManage)}
        label={handleValidateCodevalue(internationalise,'LEAD_SEARCH_OWNER')}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event, Owner) => handleSelectOwner(event, Owner)}
    />

    <AutoCompleteComponent
        className="search-lead-autocomplete"
        limitTags={3}
        textInputStyle = {{ width: "97% !important" }}
        multiple
        isLookup={true}
        optionSet={leadStatusData}
        value={entityDetails?.status || []}
        name="status"
        placeholder={handleValidateCodevalue(internationalise,'LEAD_SEARCH_STATUS')}
        label={handleValidateCodevalue(internationalise,'LEAD_SEARCH_STATUS')}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event, Status) => handleSelectStatus(event, Status,"status")}
    />
    </StyledAccordionContainer>
    <StyledGridContainer>
        
    {leadTextfieldsData?.firstName?.visibility && (
        <TextFiledWithLabel
            name="firstName"
            value={entityDetails?.firstName}
            label={handleValidateCodevalue(internationalise,"LEAD_SEARCH_FIRSTNAME")} 
            inputRef={inputSearchRef}
            handleOnChange={handleOnChange}
        />
    )}    
    {leadTextfieldsData?.lastName?.visibility && (
        <TextFiledWithLabel
            name="lastName"
            value={entityDetails?.lastName}
            label={handleValidateCodevalue(internationalise,"LEAD_SEARCH_LASTNAME")} 
            inputRef={inputSearchRef}
            handleOnChange={handleOnChange}
        />
    )}
        <PhoneNumberField
            name="phone"
            countryCodeName="phoneCountryCode"
            countryCode={entityDetails?.phoneCountryCode || "+91"}
            value={entityDetails?.phone}
            handleOnChange={handleOnChange}
        />
        <CommonEmail
            name = 'email'
            value={entityDetails?.email}
            handleOnChange={handleOnChange}
        />
                    
    {leadTextfieldsData?.desirability?.visibility && (
        <SelectBoxWithLabel
            name= "desirability"
            ownerdropdown={false}
            isStatic={false}
            value= {entityDetails?.desirability ?? ""}
            label={handleValidateCodevalue(internationalise,'LEAD_SEARCH_DESIRABILITY')}
            optionMenuItem={leadDesrirabilityData}
            handleOnChange={handleOnChange}
        />
    )}
                 <ChooseProductType
                    value={entityDetails?.productId || ""}
                    searchState={entityDetails}
                    handleChangeSearchField={handleOnChange} 
                />
   
     
            
    </StyledGridContainer>
            <StyledFieldBox className="search-lead-field-box">
                <NumericTextField
                    name="priceFrom"
                    maxLength = {15}
                    value={entityDetails?.priceFrom}
                    label={handleValidateCodevalue(internationalise,"LEAD_SEARCH_TOTAL_VAL_MIN")} 
                    handleOnChange={handleOnChange}/>
                <NumericTextField
                    name="priceTo"
                    maxLength = {15}
                    value={entityDetails?.priceTo}
                    label={handleValidateCodevalue(internationalise,"LEAD_SEARCH_TOTAL_VAL_MAX")} 
                    handleOnChange={handleOnChange}/>
            </StyledFieldBox>
    
    <CommonPoc
        handleOnChange={handleOnChange}
        state={entityDetails}
    />
    <WhoColumns
        searchState = {entityDetails}
        handleOnChange = {handleOnChange}
    />
</Box>

  );
}

export default SearchLeadComponenet;
